import { Phone, Mail, MapPin, Instagram } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="container mx-auto px-6 sm:px-8 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white leading-tight">
              Future-Proof Your <br /> Business with ZID <br /> IT Solutions.
            </h2>
            <a
              href="#contact"
              data-testid="footer-cta-btn"
              className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 mt-8 transition-colors"
            >
              Get a Free Quote
            </a>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading font-bold text-white mb-5">Services</h3>
            <ul className="space-y-3 text-sm">
              {["Network Solutions", "Structured Cabling", "Security Cameras", "Cable Management", "Rack and Stack", "IT Services", "Printers", "Data Backup & Drive Cloning", "Microsoft 365 & Google Workspace", "Smart Thermostat Installation", "Website Design & Development", "Application Support"].map((s) => (
                <li key={s}>
                  <a href="#services" className="hover:text-white transition-colors">{s}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading font-bold text-white mb-5">Service Areas</h3>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm" data-testid="footer-service-areas">
              {["Ajax", "Bowmanville", "Brampton", "Burlington", "Courtice", "Hamilton", "Markham", "Milton", "Mississauga", "Newmarket", "Oakville", "Oshawa", "Richmond Hill", "Toronto", "Vaughan", "Whitby"].map((c) => (
                <li key={c} className="flex items-center gap-2">
                  <MapPin size={13} className="text-blue-500 flex-shrink-0" />
                  {c}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading font-bold text-white mb-5">Contact</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-blue-500" />
                <a href="tel:+19055985264" className="hover:text-white transition-colors">905.598.5264</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-blue-500" />
                <a href="mailto:support@ziditsolutions.ca" className="hover:text-white transition-colors">support@ziditsolutions.ca</a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram size={16} className="text-blue-500" />
                <a href="https://instagram.com/ziditsolutions" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">@ziditsolutions</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-blue-500 mt-0.5" />
                <span>Serving businesses & homes locally</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-16 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/3obxc0re_logo-transparent-png.webp"
              alt="ZID IT Solutions logo"
              className="h-14 w-auto object-contain"
            />
            <span className="font-heading font-black text-white text-lg">ZID <span className="text-blue-500">IT</span> Solutions</span>
          </div>
          <span>© {new Date().getFullYear()} ZID IT Solutions. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};
